export default __webpack_public_path__ + "static/media/10.76c42e15.png";